// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__37lDj","calendarButtons":"ClockData_calendarButtons__VGcMZ"};